import React, { useEffect, useState } from 'react'
import './portfolio.css'
import Card from './Card'
import Filter from './Filter'
import {
  featuredPortfolio,
  cmsPortfolio,
  reactPortfolio,
  layoutPortfolio,
  webAppPortfolio,
} from "./data";
import Aos from 'aos';
import 'aos/dist/aos.css';

const Portfolio = () => {

  const [selected, setSelected] = useState("featured");
  const [data, setData] = useState([]);
  const list = [
    {
      id: "featured",
      title: "FEATURED",
    },
    {
      id: "react",
      title: "REACT JS",
    },
    {
      id: "cms",
      title: "CMS",
    },
    {
      id: "layout",
      title: "LAYOUTS",
    },
    /* {
      id: "webapp",
      title: "WEB APP",
    }, */
  ];

  useEffect(() => {
    switch (selected) {
      case "featured":
        setData(featuredPortfolio);
        break;
      case "cms":
        setData(cmsPortfolio);
        break;
      case "react":
        setData(reactPortfolio);
        break;
      case "layout":
        setData(layoutPortfolio);
        break;
      case "webapp":
        setData(webAppPortfolio);
        break;
      default:
        setData(featuredPortfolio);
    }
  }, [selected]);

  //Animation
  useEffect(() => {
    Aos.init({duration: 2000});
  },[])


  return (
    <>
      <section id='portfolio' className='portfolio container'>
        <div className='portfolio__container'>
          <div data-aos="zoom-in" className='container__heading'>
            <h4>MY RECENT WORKS</h4>
            <h1>My Portfolio</h1>
          </div>


          <div data-aos="fade-up" className='filter'>
            <div className='filter__container'>
              <ul>
                {list.map((item, index) => (
                  <Filter
                    key={index}
                    title={item.title}
                    active={selected === item.id}
                    setSelected={setSelected}
                    id={item.id}
                  />
                ))}
              </ul>
            </div>
          </div>

          <div data-aos="fade-up" className='container__content'>
            {data.map((item, index) => {
              return <Card 
                key={index} 
                image={item.image}
                category={item.category}
                detail={item.detail}
                title={item.title}
                github={item.github}
                demo={item.demo}
                description={item.description}/>
            })}
          </div>
        </div>
    </section>
    </>
  )
}

export default Portfolio